import React from 'react'
import { OS, identifyOS } from 'core/services/browser'
import { Banner, BannerType } from './banner'

const os = identifyOS()

interface IByPlatformBannerProps {
  iosBody?: string
  androidBody?: string
  desktopBody?: string
  iosLink?: string
  androidLink?: string
  desktopLink?: string
  cta: string
  localStorageKey: string
  bannerType: BannerType
}

export const ByPlatformBanner: React.FunctionComponent<IByPlatformBannerProps> = ({
  iosBody,
  androidBody,
  desktopBody,
  iosLink,
  androidLink,
  desktopLink,
  cta,
  localStorageKey,
  bannerType
}) => {
  if (os === OS.ios && iosBody && iosLink) {
    return (
      <Banner
        bannerType={bannerType}
        body={iosBody}
        link={iosLink}
        cta={cta}
        localStorageKey={localStorageKey}
      />
    )
  }
  if (os === OS.android && androidBody && androidLink) {
    return (
      <Banner
        bannerType={bannerType}
        body={androidBody}
        link={androidLink}
        cta={cta}
        localStorageKey={localStorageKey}
      />
    )
  }

  if (!(os === OS.android || os === OS.ios) && desktopLink && desktopBody) {
    return (
      <Banner
        bannerType={bannerType}
        body={desktopBody}
        link={desktopLink}
        cta={cta}
        localStorageKey={localStorageKey}
      />
    )
  }
  return null
}
